// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__31VXM","productName":"Table_productName__w8tPm"};